import Vue from 'vue';
import Vuex from 'vuex';
import moment from 'moment';
import layout_module from '@/store/layout_module';

Vue.use(Vuex);

export const SET_LANGUAGE = 'SET_LANGUAGE';
export const SET_BOOKLETS = 'SET_BOOKLETS';
export const SET_TOKEN = 'SET_TOKEN';
export const SET_DATA = 'SET_DATA';
export const SET_UNIT = 'SET_UNIT';
export const SET_DEBUG = 'SET_DEBUG';
export const SET_TRACKING = 'SET_TRACKING';

const store = new Vuex.Store({
  state: {
    lang: 'en',
    debug: false,
    tracking: true,
    token: '',
    data: null,
    unit: 'standard',
    booklets: []
  },
  getters: {
    langAndTokenSet: (state) => {
      return state.lang && state.token;
    },
    debug: (state) => {
      return state.debug
    },
    userDataSet: (state) => {
      return state.data !== null;
    },
    goalDetailById: (state: any) => (id: string) => {
      if (!state.data.goals || state.data.goals.length === 0) {
        return null;
      }
      if (id === 'latest') {
        return state.data.goals[0];
      }
      else {
        return state.data.goals.find((val: any) => {
          return val.goalKey.toString() === id.toString()
        });
      }
    }
  },
  mutations: {
    [SET_LANGUAGE](state, language) {
      state.lang = language;
      moment.locale(language);
    },
    [SET_TOKEN](state, token) {
      state.token = token;
    },
    [SET_DEBUG](state, debug) {
      state.debug = debug;
    },
    [SET_TRACKING](state, tracking) {
      state.tracking = tracking;
    },
    [SET_UNIT](state, unit) {
      state.unit = unit;
    },
    [SET_DATA](state, data) {
      state.data = data;
    },
    [SET_BOOKLETS](state, booklets) {
      state.booklets = booklets;
    },
  },
  actions: {

  },
  modules: {
    layout: layout_module
  }
});

export default store;